import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import { Link } from "react-router-dom";

const howToStructuredData = [
  {
    "@type": "HowTo",
    name: "雷撃カゴと天秤のセッティング手順",
    description: "雷撃カゴと天秤のセッティング手順を詳しく解説。L字型パイプ天秤の通し方、ショート天秤とロング天秤の違い、仕掛けの構成、上級者テクニックまで完全ガイド。",
    image: "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/c3c53ddeaf5529cebde61a96dc43c2c6.jpeg",
    estimatedCost: {
      "@type": "MonetaryAmount",
      currency: "JPY",
      value: "400",
    },
    tool: [
      { "@type": "HowToTool", name: "雷撃カゴ" },
      { "@type": "HowToTool", name: "L字型パイプ天秤（ショート天秤またはロング天秤）" },
      { "@type": "HowToTool", name: "道糸（メインライン）" },
      { "@type": "HowToTool", name: "ハリス" },
      { "@type": "HowToTool", name: "針" },
      { "@type": "HowToTool", name: "サルカン" },
      { "@type": "HowToTool", name: "シモリ玉" },
      { "@type": "HowToTool", name: "コマセ（撒き餌）" },
    ],
    step: [
      {
        "@type": "HowToStep",
        position: "1",
        name: "天秤に道糸を通す",
        text: "L字型パイプ天秤を使った道糸の通し方。まず道糸（メインライン）に上側のシモリ玉を通します。次にL字型パイプ天秤の向きに注意し、リブ（ハリを掛ける突起）がない方を上にして天秤に道糸を通します。さらに下側のシモリ玉を通し、サルカンに道糸を結びます。",
        image: "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/c38c8ca12631436b17ef33a21560c235.jpeg",
      },
      {
        "@type": "HowToStep",
        position: "2",
        name: "雷撃カゴを取り付ける",
        text: "サルカンを結んだら、天秤のスナップを使って雷撃カゴを接続します。天秤のスナップを開いて雷撃カゴのサルカンに通し、スナップがしっかりロックされていることを確認します。カゴは数字の書いてある膨らみの大きい方が上側で、オモリの内蔵されている下側を先頭にして飛んで行きます。",
        image: "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/4d5b55d8e57507fb98665f656e5bdd61.jpeg",
      },
      {
        "@type": "HowToStep",
        position: "3",
        name: "ハリスと針をセットする",
        text: "サルカンにハリスを結び、ハリスを2.5ヒロ～3ヒロ取ります。ハリスに針を結び、お好みでハリスまたは道糸にガン玉ないし水中ウキを取り付けます。",
        image: "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/600d1d4f908154f818c6eb04662134f1.jpeg",
      },
      {
        "@type": "HowToStep",
        position: "4",
        name: "コマセを詰めてキャスト",
        text: "雷撃カゴにコマセ（撒き餌）を詰めます。詰めすぎるとコマセが出なくなるため、カゴの7～8割程度を目安にします。針と刺し餌を天秤のリブ（突起）に引っ掛けます。キャスト時は天秤が回転しないよう、スムーズなフォームで振り抜きます。着水後はカゴからコマセが自然に放出されるのを待ちます。",
        image: "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/9d72256296b24c7343210d82b4608166.png",
      },
    ],
  },
  {
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "ショート天秤とロング天秤、どちらを選べばいいですか？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "糸絡み頻度や、潮の流れ、魚のタナなどによって使い分けます。横風が強くて糸絡みが多い時はロング天秤を、潮が速かったり魚のタナが深い時はショート天秤を使います。",
        },
      },
      {
        "@type": "Question",
        name: "雷撃カゴの浮力はどれくらいですか？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "カゴのサイズによって異なりますが、目安として浮力3号程度とお考え下さい。",
        },
      },
      {
        "@type": "Question",
        name: "どの雷撃カゴのサイズを使えばいいかわかりません",
        acceptedAnswer: {
          "@type": "Answer",
          text: "詳しくは製品スペックをご覧頂きたいのですが、大まかには数字の番号が大きいほど飛距離と対象魚種も大きくなるとお考え下さい。マキエの量も数字が大きいほど多く撒くことができます。",
        },
      },
      {
        "@type": "Question",
        name: "雷撃カゴの耐久性はどのくらいですか？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "3Dプリント製の雷撃カゴは高強度素材を使用しており、通常使用では長期間の耐久性があります。紫外線にも強く劣化しにくい素材です。ただし岩などへの激しい衝突や過度な負荷がかかると破損する可能性があるため、無理なご使用はお控え下さい。",
        },
      },
      {
        "@type": "Question",
        name: "初心者でも雷撃カゴ仕掛けは使えますか？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "もちろんです。雷撃カゴ仕掛けはむしろ初心者の方におすすめで、専用の天秤を使うことでタラシ（ハリス）を短くでき投げやすくなります。初心者の方でも遠くに投げることが可能で、キャスティングの爽快感を感じられます。まずは糸絡みの少ないロング天秤と雷撃カゴ00または01の組み合わせから始めてみてください。",
        },
      },
    ],
  },
  {
    "@type": "VideoObject",
    name: "仕掛けの作り方",
    description: "雷撃カゴと天秤を使った仕掛けの作り方を動画でわかりやすく解説します。",
    thumbnailUrl: "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/c3c53ddeaf5529cebde61a96dc43c2c6.jpeg",
    contentUrl: "https://www.youtube.com/watch?v=Xh3t68vxx98",
    embedUrl: "https://www.youtube.com/embed/Xh3t68vxx98",
    uploadDate: "2025-01-01",
    duration: "PT10M",
  },
];

export default function HowTo() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 150);
      }
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-100">
      <SEOHead
        title="雷撃カゴと天秤の使い方｜セッティング手順と仕掛けの構成｜ハヤブサワークス"
        description="雷撃カゴと天秤のセッティング手順を詳しく解説。L字型パイプ天秤の通し方、ショート天秤とロング天秤の違い、仕掛けの構成、上級者テクニックまで完全ガイド。"
        keywords="雷撃カゴ 使い方,天秤 セッティング,カゴ釣り 仕掛け,遠投カゴ セッティング,ハヤブサワークス"
        canonicalPath="/how-to"
        ogType="article"
        ogImage="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/cfb5afee631d88a7b12672494ae842fb.jpeg"
        structuredData={howToStructuredData}
      />
      <Navbar />

      <main>
        {/* Hero */}
        <section id="how-to-use" className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/c3c53ddeaf5529cebde61a96dc43c2c6.jpeg"
            alt="雷撃カゴと天秤の使い方"
            title="雷撃カゴと天秤の使い方"
            className="w-full h-full object-cover"
            style={{ objectPosition: "50% 40%" }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-white/35 via-white/10 to-white/55"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <span
              className="text-background-50/80 text-xs tracking-[0.4em] mb-6"
              style={{ fontFamily: "var(--font-label)" }}
            >
              HOW TO USE
            </span>
            <h1
              className="text-background-50 text-3xl md:text-5xl leading-[1.05] max-w-4xl whitespace-nowrap"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              雷撃カゴと天秤の使い方
            </h1>
            <p className="text-background-50/80 text-sm md:text-base max-w-xl mt-6 leading-relaxed">
              雷撃カゴと天秤のセッティングから実釣まで、基本をマスターして釣果アップを目指しましょう。
            </p>
          </div>
        </section>

        {/* What is Raigeki Kago */}
        <section className="w-full px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-24">
          <div className="flex flex-col lg:flex-row lg:items-center gap-10 lg:gap-12">
            <div className="lg:w-[42%]">
              <div className="flex items-center gap-3 mb-5">
                <span className="w-8 h-[2px] bg-accent-500"></span>
                <span
                  className="text-accent-500 text-xs tracking-[0.4em]"
                  style={{ fontFamily: "var(--font-label)" }}
                >
                  WHAT IS RAIGEKI KAGO
                </span>
              </div>
              <h2
                className="text-foreground-950 text-3xl md:text-5xl leading-[1.1] mb-8"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                雷撃カゴとは？
              </h2>
              <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                <p>
                  雷撃カゴとは、３Ｄプリンタで製作された次世代カゴウキです。空力最適化されたロケット型構造により横風でもブレず、圧倒的な飛距離を叩き出します。
                </p>
                <p>
                  雷撃カゴ専用天秤を用いることで投げやすさが飛躍的に向上します。
                </p>
              </div>
            </div>
            <div className="lg:w-[58%]">
              <div className="relative aspect-[16/11] rounded-lg overflow-hidden bg-background-100">
                <img
                  src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/bf09b1a114e9984f31653dece5d49de3.jpeg"
                  alt="雷撃カゴの飛行メカニズム"
                  title="雷撃カゴの飛行メカニズム"
                  className="w-full h-full object-contain p-4"
                />
              </div>
            </div>
          </div>
        </section>

        {/* What is Tenbin */}
        <section className="w-full px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-24">
          <div className="flex flex-col lg:flex-row lg:items-center gap-10 lg:gap-20">
            <div className="lg:w-1/2">
              <div className="flex items-center gap-3 mb-5">
                <span className="w-8 h-[2px] bg-primary-500"></span>
                <span
                  className="text-primary-500 text-xs tracking-[0.4em]"
                  style={{ fontFamily: "var(--font-label)" }}
                >
                  WHAT IS TENBIN
                </span>
              </div>
              <h2
                className="text-foreground-950 text-3xl md:text-5xl leading-[1.1] mb-8"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                天秤とは？
              </h2>
              <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                <p>
                  天秤（てんびん）は、カゴ釣りにおいて仕掛けを安定させ糸絡みを減らす重要なパーツです。雷撃カゴとの組み合わせにより、最適なバランスと飛距離を実現します。
                </p>
                <p>
                  さらに、雷撃カゴの専用天秤は、針を掛ける部分（リブ）を独自に設けることにより、ハリスを折り返すことが可能なため長ハリスも使用可能です。タラシ（ハリス部分）が短くなることで、投げる時、後ろの障害物が気にならなくなります。
                </p>
              </div>
            </div>
            <div className="lg:w-1/2">
              <div className="grid grid-cols-2 gap-4">
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
                  <img
                    src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/5df6b785e25d020e60fe1aa027fa88ec.jpeg"
                    alt="ショート天秤"
                    title="ショート天秤"
                    className="w-full h-full object-contain p-4"
                  />
                </div>
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
                  <img
                    src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/8a3c651874a8528a0858a46e78f1c7ad.jpeg"
                    alt="ロング天秤"
                    title="ロング天秤"
                    className="w-full h-full object-contain p-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Short vs Long Tenbin */}
        <section className="w-full bg-background-100 border-y border-background-200/60">
          <div className="px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-24">
            <div className="text-center mb-12 md:mb-16">
              <div className="flex items-center justify-center gap-3 mb-5">
                <span className="w-8 h-[2px] bg-accent-500"></span>
                <span
                  className="text-accent-500 text-xs tracking-[0.4em]"
                  style={{ fontFamily: "var(--font-label)" }}
                >
                  COMPARISON
                </span>
                <span className="w-8 h-[2px] bg-accent-500"></span>
              </div>
              <h2
                className="text-foreground-950 text-3xl md:text-5xl leading-[1.1]"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                ショート天秤とロング天秤の違い
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
              {/* Short Tenbin */}
              <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-8">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm">
                    S
                  </div>
                  <h3
                    className="text-foreground-950 text-xl"
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    ショート天秤
                  </h3>
                </div>
                <ul className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                  <li className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 rounded-full bg-primary-500 text-background-50 text-[10px]">
                      <i className="ri-arrow-down-line"></i>
                    </span>
                    ロング天秤より糸落ちが速い
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 rounded-full bg-secondary-500 text-background-50 text-[10px]">
                      <i className="ri-alert-line"></i>
                    </span>
                    ロング天秤よりは糸絡みが発生しやすい
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[10px]">
                      <i className="ri-shopping-basket-line"></i>
                    </span>
                    推奨カゴサイズ「00」「01」
                  </li>
                </ul>
                <div className="mt-5 pt-5 border-t border-background-200/60">
                  <span className="text-foreground-950 text-2xl" style={{ fontFamily: "var(--font-heading)" }}>
                    &yen;400
                  </span>
                  <span className="text-foreground-600 text-xs ml-1">（税込）</span>
                </div>
              </div>

              {/* Long Tenbin */}
              <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-8">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-sm">
                    L
                  </div>
                  <h3
                    className="text-foreground-950 text-xl"
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    ロング天秤
                  </h3>
                </div>
                <ul className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                  <li className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 rounded-full bg-accent-500 text-background-50 text-[10px]">
                      <i className="ri-arrow-down-line"></i>
                    </span>
                    ショート天秤より糸落ちがゆるやか
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 rounded-full bg-accent-500 text-background-50 text-[10px]">
                      <i className="ri-check-line"></i>
                    </span>
                    糸絡みが発生しにくい
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[10px]">
                      <i className="ri-shopping-basket-line"></i>
                    </span>
                    推奨カゴサイズ「02」「03」
                  </li>
                </ul>
                <div className="mt-5 pt-5 border-t border-background-200/60">
                  <span className="text-foreground-950 text-2xl" style={{ fontFamily: "var(--font-heading)" }}>
                    &yen;850
                  </span>
                  <span className="text-foreground-600 text-xs ml-1">（税込）</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Rigging Diagrams */}
        <section className="w-full bg-background-100 border-y border-background-200/60">
          <div className="px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-24">
            <div className="text-center mb-12 md:mb-16">
              <div className="flex items-center justify-center gap-3 mb-5">
                <span className="w-8 h-[2px] bg-primary-500"></span>
                <span
                  className="text-primary-500 text-xs tracking-[0.4em]"
                  style={{ fontFamily: "var(--font-label)" }}
                >
                  RIGGING
                </span>
                <span className="w-8 h-[2px] bg-primary-500"></span>
              </div>
              <h2
                className="text-foreground-950 text-3xl md:text-5xl leading-[1.1]"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                仕掛けの構成
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {/* Image 1 - Full Rig Diagram */}
              <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60">
                <div className="relative aspect-[3/4] p-4">
                  <img
                    src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/880eaed94d0638d2be91f136f34f56c2.jpeg"
                    alt="仕掛けの一例"
                    title="仕掛けの一例"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="px-4 pb-4 pt-0 text-center">
                  <p className="text-foreground-700 text-sm" style={{ fontFamily: "var(--font-heading)" }}>
                    仕掛けの一例
                  </p>
                </div>
              </div>

              {/* Image 2 - L-shaped pipe balance detail */}
              <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60">
                <div className="relative aspect-[3/4] p-4">
                  <img
                    src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/8835c2d7fb3870613a604721b9cd11c8.jpeg"
                    alt="L型パイプ天秤の詳細"
                    title="L型パイプ天秤の詳細"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="px-4 pb-4 pt-0 text-center">
                  <p className="text-foreground-700 text-sm" style={{ fontFamily: "var(--font-heading)" }}>
                    針をリブ（突起）に掛けた図
                  </p>
                </div>
              </div>

              {/* Image 3 - Rib close-up */}
              <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60">
                <div className="relative aspect-[3/4] p-4">
                  <img
                    src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/835f0251c8f56538cdedc5fe07a93f7a.jpeg"
                    alt="リブ（突起）部分のアップ"
                    title="リブ（突起）部分のアップ"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="px-4 pb-4 pt-0 text-center">
                  <p className="text-foreground-700 text-sm" style={{ fontFamily: "var(--font-heading)" }}>
                    リブ（突起）部分のアップ
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Step by Step */}
        <section
          id="steps"
          className="w-full px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-24 border-t border-background-200/60"
        >
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-5">
              <span className="w-8 h-[2px] bg-primary-500"></span>
              <span
                className="text-primary-500 text-xs tracking-[0.4em]"
                style={{ fontFamily: "var(--font-label)" }}
              >
                STEP BY STEP
              </span>
              <span className="w-8 h-[2px] bg-primary-500"></span>
            </div>
            <h2
              className="text-foreground-950 text-3xl md:text-5xl leading-[1.1]"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              セッティング手順
            </h2>
          </div>

          {/* Step Cards */}
          <div className="space-y-6 md:space-y-10">
            {steps.map((step, i) => (
              <div
                key={step.id}
                className="group flex flex-col md:flex-row gap-6 md:gap-10 items-start"
              >
                {/* Step Number + Image */}
                <div className="w-full md:w-[340px] shrink-0">
                  <div className="relative aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
                    <img
                      src={step.image}
                      alt={step.title}
                      title={step.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      style={{ objectPosition: "50% 50%" }}
                    />
                    <div className="absolute top-4 left-4">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 pt-2">
                  <h3
                    className="text-foreground-950 text-xl md:text-2xl mb-4"
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    {step.title}
                  </h3>
                  <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
                    {step.description}
                  </p>
                  {step.points && (
                    <ul className="space-y-2">
                      {step.points.map((pt, j) => (
                        <li
                          key={j}
                          className="flex items-start gap-3 text-sm text-foreground-700"
                        >
                          <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 rounded-full bg-primary-500 text-background-50 text-[10px]">
                            <i className="ri-check-line"></i>
                          </span>
                          {pt}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Video */}
        <section className="w-full px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-24">
          <div className="text-center mb-12 md:mb-16">
            <div className="flex items-center justify-center gap-3 mb-5">
              <span className="w-8 h-[2px] bg-primary-500"></span>
              <span
                className="text-primary-500 text-xs tracking-[0.4em]"
                style={{ fontFamily: "var(--font-label)" }}
              >
                VIDEO
              </span>
              <span className="w-8 h-[2px] bg-primary-500"></span>
            </div>
            <h2
              className="text-foreground-950 text-3xl md:text-5xl leading-[1.1]"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              仕掛けの作り方
            </h2>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="relative aspect-video rounded-lg overflow-hidden bg-background-100">
              <iframe
                src="https://www.youtube.com/embed/Xh3t68vxx98"
                title="仕掛けの作り方"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="absolute inset-0 w-full h-full"
              ></iframe>
            </div>
          </div>
        </section>

        {/* Tips */}
        <section
          id="tips"
          className="w-full bg-background-100 border-y border-background-200/60"
        >
          <div className="px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-24">
            <div className="text-center mb-16">
              <div className="flex items-center justify-center gap-3 mb-5">
                <span className="w-8 h-[2px] bg-accent-500"></span>
                <span
                  className="text-accent-500 text-xs tracking-[0.4em]"
                  style={{ fontFamily: "var(--font-label)" }}
                >
                  PRO TIPS
                </span>
                <span className="w-8 h-[2px] bg-accent-500"></span>
              </div>
              <h2
                className="text-foreground-950 text-3xl md:text-5xl leading-[1.1]"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                上級者テクニック
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {tips.map((tip) => (
                <div
                  key={tip.id}
                  className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/60 hover:border-primary-500/30 transition-colors duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-background-50 mb-5">
                    <i className={`${tip.icon} text-xl`}></i>
                  </div>
                  <h4
                    className="text-foreground-950 text-lg mb-3"
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    {tip.title}
                  </h4>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {tip.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-24">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-5">
              <span className="w-8 h-[2px] bg-secondary-500"></span>
              <span
                className="text-secondary-500 text-xs tracking-[0.4em]"
                style={{ fontFamily: "var(--font-label)" }}
              >
                FAQ
              </span>
              <span className="w-8 h-[2px] bg-secondary-500"></span>
            </div>
            <h2
              className="text-foreground-950 text-3xl md:text-5xl leading-[1.1]"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              よくある質問
            </h2>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {faqs.map((faq, i) => (
              <details
                key={i}
                className="group border border-background-200/60 rounded-lg overflow-hidden"
              >
                <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer hover:bg-background-100 transition-colors list-none">
                  <span
                    className="text-foreground-950 text-sm md:text-base pr-8"
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    {faq.q}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center shrink-0 rounded-full border border-background-300/60 text-foreground-600 group-open:rotate-45 transition-transform duration-300">
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="relative w-full overflow-hidden">
          <img
            src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/564c338d62d3738b088cd762f2d3ab7c.png"
            alt="製品を見る"
            title="製品を見る"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: "50% 60%" }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white/80"></div>
          <div className="relative px-6 md:px-10 max-w-[1600px] mx-auto py-24 md:py-32 flex flex-col items-center text-center">
            <h2
              className="text-foreground-950 text-3xl md:text-5xl leading-[1.15] max-w-2xl mb-6"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              さあ、次の一匹を狙いに行こう
            </h2>
            <p className="text-foreground-700 text-sm md:text-base max-w-lg mb-10 leading-relaxed">
              「実によく釣れる！」雷撃カゴと天秤で、あなたの釣りをもう一段階上のレベルへ。製品ラインナップをご覧ください。
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/#product"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-xs tracking-[0.3em] whitespace-nowrap hover:bg-primary-600 transition cursor-pointer"
                style={{ fontFamily: "var(--font-label)" }}
              >
                製品を見る
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/#contact"
                className="px-8 py-3.5 rounded-full border border-foreground-300 text-foreground-700 text-xs tracking-[0.3em] whitespace-nowrap hover:bg-foreground-100/20 transition cursor-pointer"
                style={{ fontFamily: "var(--font-label)" }}
              >
                お問い合わせ
                <i className="ri-mail-line ml-2"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

/* ========== Data ========== */

const steps = [
  {
    id: "step-1",
    title: "天秤に道糸を通す",
    description:
      "L字型パイプ天秤を使った道糸の通し方です。シモリ玉と天秤の向きに注意しながら、以下の手順でセットしてください。",
    points: [
      "① まず道糸（メインライン）に上側のシモリ玉を通します。",
      "② 次にＬ字型パイプ天秤の向きに注意します。リブ（ハリを掛ける突起）が「ない」方が上になります。リブがない方を上にしてＬ字型パイプ天秤に道糸を通します。",
      "③ 天秤に糸が通ったら、さらに下側のシモリ玉を通します。",
      "④ 上側のシモリ玉 → Ｌ字型パイプ → 下側のシモリ玉に道糸が通ったのを確認したら、サルカンに道糸を結びます。",
    ],
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/c38c8ca12631436b17ef33a21560c235.jpeg",
  },
  {
    id: "step-2",
    title: "雷撃カゴを取り付ける",
    description:
      "サルカンを結んだら、天秤のスナップを使って雷撃カゴを接続します。以下の手順で確実にセットしてください。",
    points: [
      "・サルカンを結んだら、天秤に雷撃カゴを接続します。",
      "・天秤のスナップを開いて、雷撃カゴのサルカンにスナップを通します。",
      "・スナップが開かないよう、しっかりとロックされていることを確認して下さい。",
      "・カゴは数字の書いてある膨らみの大きい方が上側となります。",
      "・カゴはオモリの内蔵されている下側を先頭にして飛んで行きます。",
    ],
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/4d5b55d8e57507fb98665f656e5bdd61.jpeg",
  },
  {
    id: "step-3",
    title: "ハリスと針をセットする",
    description:
      "サルカンにハリスを結び、針を取り付けて仕掛けを完成させます。以下の手順でセットしてください。",
    points: [
      "⑤ サルカンにハリスを結びます。",
      "⑥ ハリスを2.5ヒロ～3ヒロ取ります。",
      "⑦ ハリスに針を結びます。",
      "⑧ お好みでハリスまたは道糸に、ガン玉ないし水中ウキを取り付けます。",
    ],
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/600d1d4f908154f818c6eb04662134f1.jpeg",
  },
  {
    id: "step-4",
    title: "コマセを詰めてキャスト",
    description:
      "雷撃カゴにコマセ（撒き餌）を詰めてキャストします。着水後はカゴからコマセが自然に放出されるのを待ちます。",
    points: [
      "⑨雷撃カゴにコマセ（撒き餌）を詰めます。",
      "詰めすぎるとコマセが出なくなるので、カゴの7～8割程度を目安に。",
      "⑩針と刺し餌を、天秤のリブ（突起）に引っ掛けます。",
      "キャスト時は天秤が回転しないよう、スムーズなフォームで振り抜きます。",
      "着水後はカゴからコマセが自然に放出されるのを待ちます。",
    ],
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/9d72256296b24c7343210d82b4608166.png",
  },
];

const tips = [
  {
    id: "tip-1",
    icon: "ri-compass-3-line",
    title: "サミング技術",
    description:
      "キャスティング時、カゴが着水する少し前にサミングをすると、針が仕掛けより先行して着水するため糸絡みが減ります。",
  },
  {
    id: "tip-2",
    icon: "ri-focus-3-line",
    title: "マキエワーク",
    description:
      "カゴにマキエを詰めすぎるとマキエが詰まるため、カゴの7～8割を目安に入れましょう。集魚材を少し混ぜるとマキエの放出がスムースになります。",
  },
  {
    id: "tip-3",
    icon: "ri-settings-3-line",
    title: "天秤の使い分け",
    description:
      "使い分けは、ショート天秤は糸落ちが速いため、潮が速い時や魚のタナが深い時に使用し、ロング天秤は糸落ちがゆるやかなため、潮がゆっくりな時や魚にゆっくりとアピールしたい時に使用することもできます。",
  },
];

const faqs = [
  {
    q: "ショート天秤とロング天秤、どちらを選べばいいですか？",
    a: "糸絡み頻度や、潮の流れ、魚のタナなどによって使い分けます。横風が強くて糸絡みが多い時はロング天秤を、潮が速かったり魚のタナが深い時はショート天秤を使います。",
  },
  {
    q: "雷撃カゴの浮力はどれくらいですか？",
    a: "カゴのサイズによって異なりますが、目安として浮力3号程度とお考え下さい。",
  },
  {
    q: "どの雷撃カゴのサイズを使えばいいかわかりません",
    a: "詳しくは製品スペックをご覧頂きたいのですが、大まかには数字の番号が大きいほど飛距離と対象魚種も大きくなるとお考え下さい。マキエの量も数字が大きいほど多く撒くことができます。",
  },
  {
    q: "雷撃カゴの耐久性はどのくらいですか？",
    a: "3Dプリント製の雷撃カゴは高強度素材を使用しており、通常使用では長期間の耐久性があります。紫外線にも強く劣化しにくい素材です。ただし岩などへの激しい衝突や過度な負荷がかかると破損する可能性があるため、無理なご使用はお控え下さい。",
  },
  {
    q: "初心者でも雷撃カゴ仕掛けは使えますか？",
    a: "もちろんです。雷撃カゴ仕掛けはむしろ初心者の方におすすめで、専用の天秤を使うことでタラシ（ハリス）を短くでき投げやすくなります。初心者の方でも遠くに投げることが可能で、キャスティングの爽快感を感じられます。まずは糸絡みの少ないロング天秤と雷撃カゴ00または01の組み合わせから始めてみてください。",
  },
];